(function () {
    var ProfileController = /** @class */ (function () {
        function ProfileController($scope, $q, localStorageService, MKioskService, $mdDialog, $message, $mdBottomSheet, AuthService, cacheMemoryService, CameraService) {
            this.$scope = $scope;
            this.$q = $q;
            this.localStorageService = localStorageService;
            this.MKioskService = MKioskService;
            this.$mdDialog = $mdDialog;
            this.$message = $message;
            this.$mdBottomSheet = $mdBottomSheet;
            this.AuthService = AuthService;
            this.memoryCache = cacheMemoryService.get("homepage");
            this.cameraService = CameraService;

            this.updatingAvatar = false;
            this.ready = false;
            this.showBankAccount = false;

            // NF-760: Languages for select
            this.availableLanguages = [];

            var modules = this.memoryCache.get('modules');
            // console.log('modules ', modules);
            if (modules && modules.HomeCharges) {
                this.showBankAccount = true;
            }

            this.user = null;
            this.init();
        }


        ProfileController.prototype.initMark = function () {            
            $("#BankAccountNumber").inputmask("**** **** **** **** **** **** **** ****", { casing: "upper" });  //static mask
        }
        
        ProfileController.prototype.init = function () {
            var _this = this;

            this.$q.all([
                this.MKioskService.getProfile(),
                this.MKioskService.getInputLanguages()
            ]).then(function (data) {
                _this.user = data[0];
                _this.availableLanguages = data[1];


                // default language if user dont have one
                if (!_this.user.EmailLanguage && _this.availableLanguages.length > 0) {
                    _this.user.EmailLanguage = _this.availableLanguages.find(x => x.Name === 'English') || _this.availableLanguages[0];                    
                }
                // _this.user.AvatarUrl = data.AvatarUrl;
                // _this.user.AvatarId = data.AvatarId;
                // _this.user.SendEmailForChargeCompletedSuccessfully = data.SendEmailForChargeCompletedSuccessfully;
                // _this.user.BankAccountNumber = data.BankAccountNumber; // NF-569
                _this.ready = true;
            }, this.$message.error);
        };
        ProfileController.prototype.closeDialog = function () {
            this.$mdDialog.hide();
        };
        /**
         * Update avatar
         * @param $file
         */
        ProfileController.prototype.uploadAvatar = function ($file) {
            var _this = this;
            if ($file) {
                this.$mdBottomSheet.hide();
                this.updatingAvatar = true;
                this.MKioskService.uploadFile($file)
                    .then(function (response) {
                        _this.user.AvatarId = response.data.Id

                        _this.user.AvatarUrl = window.URL.createObjectURL($file);
                        _this.updatingAvatar = false;
                    // _this.updateProfile({ AvatarId: response.data.Id })
                    //     .finally(function () {
                    //     _this.updatingAvatar = false;
                    // });
                }, this.$message.error)
                    .catch(function () {
                    _this.updatingAvatar = false;
                });
            }
        };
        /**
         * Delete avatar
         */
        ProfileController.prototype.deleteAvatar = function () {
            var _this = this;
            this.$mdBottomSheet.hide();
            // this.updatingAvatar = true;
            _this.user.AvatarId = null;
            _this.user.AvatarUrl = null;
            // this.updateProfile({
            //     AvatarId: null
            // }).finally(function () {
            //     _this.updatingAvatar = false;
            // });
        };
        ProfileController.prototype.showActionsheet = function () {
            var newScope = this.$scope.$new();
            this.$mdBottomSheet.show({
                templateUrl: 'js/internal/profile/bottom-sheet.html',
                scope: newScope,
                controllerAs: 'vm'
            });
        };
        ProfileController.prototype.updateProfile = function (propeties) {
            var _this = this;
            var profile = {
                AvatarId: this.user.AvatarId,
                AvatarUrl: this.user.AvatarUrl,
                SendEmailForChargeCompletedSuccessfully: this.user.SendEmailForChargeCompletedSuccessfully
            };
            _.extend(profile, propeties);
            return this.MKioskService.updateProfile(profile)
                .then(function (data) {
                _this.user.AvatarUrl = data.AvatarUrl;
                _this.user.AvatarId = data.AvatarId;
                _this.user.SendEmailForChargeCompletedSuccessfully = data.SendEmailForChargeCompletedSuccessfully;

                _this.AuthService.updateUserProfile(data);
            }, this.$message.error);
        };
        ProfileController.prototype.onChangeSendEmailForChargeCompletedSuccessfully = function () {
            // this.updateProfile();
        };
        ProfileController.prototype.saveProfile = function () {         
            var _this = this;
            if (_this.user.BankAccountNumber) {                                
                _this.user.BankAccountNumber = _this.user.BankAccountNumber.replaceAll('_','').replaceAll(' ','');             
            }
            return this.MKioskService.updateProfile(_this.user)
            .then(function (data) {
                // var user = this.AuthService.getAuthenticatedUser();
                // user.AvatarUrl = data.AvatarUrl;
                // user.AvatarId = data.AvatarId;
                // user.SendEmailForChargeCompletedSuccessfully = data.SendEmailForChargeCompletedSuccessfully;
                // user.BankAccountNumber = data.BankAccountNumber;
                _this.AuthService.updateUserProfile(data);
                _this.closeDialog();
        }, this.$message.error);
        };

        ProfileController.prototype.showPhoto = function ($event) {
            this.cameraService
                .showPhotosOrDocumentsPanel($event, {
                    onStart: () => {
                        this.$mdBottomSheet.hide();
                    },
                    acceptOnlyPicture: true
                })
                .then((data) => {
                    if (data) { // have file
                        // console.log('showPhoto: ', data);
                        this.uploadAvatar(data);
                    }
                });
        };
        
        ProfileController.$inject = ['$scope', '$q', 'localStorageService', 'MKioskService', '$mdDialog', '$message', '$mdBottomSheet', 'AuthService', 'CacheMemoryService','CameraService'];
        return ProfileController;
    }());
    angular.module('internal.profile').controller('ProfileController', ProfileController);
})();
